export const offerData = [
    {
        service: "Trening siłowy",
        subtitle: "Personalny",
        coach: "Michał Kulej, Jakub Kulej, Klaudia Żmijewska, Mateusz Flejterski, Tomasz Rudolf, Sandra Cieślik-Kulej, Dominik Warmiłło, Patryk Mikulski, Tomasz Mitrosz, Przemysław Gąska, Marcin Woźniak, Tomasz Wroński, Joanna Kapelańczyk, Maciej Weszka, Zuzanna Rabus",
        coachIds: [
            "MK1",
            "JK1",
            "KŻ1",
            "MF1",
            "TR1",
            "SC1",
            "DW1",
            "PM1",
            "TM1",
            "PG1",
            "MW1",
            "TW1",
            "JK2",
            "MW2",
            "ZR1",
        ],
        imgSrc: "/images/photo/gymoffer.jpg",
        imgSrc0: "/images/photo/maingym.jpg",
        imgAlt: "Zdjęcie z treningu siłowego",
        imgSrc2: "/images/galeria/gallery1.png",
        imgAlt2: "Zdjęcie z treningu siłowego",
        imgSrc3: "/images/galeria/gallery3.png",
        imgAlt3: "Zdjęcie z treningu siłowego",
        description:
            "Indywidualny trening siłowy (solo lub w parze) na siłowni to spersonalizowany program, odpowiednio dostosowany do tempa i potrzeb, który pomaga budować siłę oraz usprawniać Twoje ciało.",
        day: "Indywidualne Zapisy",
        users: "Indywidualny trening siłowy jest przeznaczony dla osób, które pragną spersonalizowanego podejścia do budowania siły i poprawy sprawności fizycznej. Jest idealny zarówno dla osób trenujących solo, jak i w parze, które cenią dostosowanie tempa i programu do własnych potrzeb i celów. To doskonały wybór dla tych, którzy chcą skutecznie rozwijać swoją kondycję pod okiem trenera, dbając o postępy w indywidualnym rytmie.",
    },
    {
        service: "Trening medyczny",
        subtitle: "Personalny",
        coach: "Klaudia Żmijewska, Michał Kulej, Mateusz Flejterski, Joanna Kapelańczyk, Sandra Cieślik-Kulej",
        coachIds: ["MK1", "KŻ1", "MF1", "JK2", "SC1"],
        imgSrc: "/images/photo/gymoffer.jpg",
        imgSrc0: "/images/photo/maingym.jpg",
        imgAlt: "Zdjęcie z treningu siłowego",
        imgSrc2: "/images/galeria/gallery1.png",
        imgAlt2: "Zdjęcie z treningu siłowego",
        imgSrc3: "/images/galeria/gallery3.png",
        imgAlt3: "Zdjęcie z treningu siłowego",
        description:
            "Spersonalizowany program ćwiczeń, który wspiera rehabilitację, poprawia mobilność i wzmacnia zastane pracą czy biurku ciało, pomagając również wrócić do pełnej sprawności po urazach czy operacjach.",
        day: "Indywidualne Zapisy",
        users: "Indywiudalny trening medyczny jest idealny dla osób potrzebujących wsparcia w rehabilitacji, poprawie mobilności oraz wzmocnieniu ciała osłabionego siedzącym trybem życia. Trening ten pomaga wrócić do pełnej sprawności po urazach lub operacjach, koncentrując się na indywidualnych potrzebach i ograniczeniach, co pozwala na bezpieczne i skuteczne odzyskiwanie formy.",
    },
    {
        service: "Trening motoryczny",
        subtitle: "Personalny",
        coach: "Michał Kulej, Jakub Kulej, Mateusz Flejterski, Tomasz Rudolf, Tomasz Wroński, Maciej Weszka, Marcin Bachórz",
        coachIds: ["MK1", "JK1", "MF1", "TR1", "TW1", "MW2", "MB1"],
        imgSrc: "/images/photo/gymoffer.jpg",
        imgSrc0: "/images/photo/maingym.jpg",
        imgAlt: "Zdjęcie z treningu motorycznego",
        imgSrc2: "/images/galeria/gallery1.png",
        imgAlt2: "Zdjęcie z treningu siłowego",
        imgSrc3: "/images/galeria/gallery3.png",
        imgAlt3: "Zdjęcie z treningu siłowego",
        description:
            "Spersonalizowany pod daną dyscyplinę sportu trening, który rozwija siłę, szybkość, zwinność i koordynację, pomagając poprawić ogólną sprawność fizyczną i wydajność sportowca.",
        day: "Indywidualne Zapisy",
        users: "Spersonalizowany trening motoryczny jest dedykowany sportowcom, którzy chcą rozwijać swoją siłę, szybkość, zwinność i koordynację. Program ten jest idealny dla osób pragnących poprawić swoją ogólną sprawność fizyczną i wydajność w danej dyscyplinie. Dzięki indywidualnemu podejściu, trening skutecznie wspiera osiąganie lepszych wyników i podnoszenie sportowych umiejętności.",
    },
    {
        service: "Kickboxing",
        subtitle: "Indywidualny",
        coach: "Michał Kulej, Jakub Kulej, Adrian Spętany, Patryk Mikulski, Marcin Bachórz, Miłosz Karyś",
        coachIds: ["MK1", "JK1", "AS1", "PM1", "MB1", "MK2"],
        imgSrc0: "/images/offercards/combat.jpg",
        imgSrc: "/images/offercards/combatoffer.jpg",
        imgAlt: "Zdjęcie zajęć kickboxingu",
        imgSrc2: "/images/kickboxing/kickboxing2.png",
        imgAlt2: "Zdjęcie z zajęć kickboxingu",
        imgSrc3: "/images/kickboxing/kickboxing1.png",
        imgAlt3: "Zdjęcie z zajęć kickboxingu",
        description:
            "Kickboxing to intensywny trening, który łączy techniki uderzanych sportów walki w stójce, skutecznie poprawiając kondycję, siłę i pewność siebie.",
        day: "Indywidualne Zapisy",
        users: "Zapraszamy na indywidualne zajęcia kickboxingu dla osób na różnych poziomach zaawansowania! To idealne miejsce, aby nauczyć się podstaw, a także rozwinąć umiejętności, które już posiadasz. Treningi prowadzone są w przyjaznej i motywującej atmosferze, gdzie każdy może pracować nad swoją kondycją, techniką i pewnością siebie. Nasz trener dostosowuje ćwiczenia do Twojego poziomu, dbając o to, żebyś mógł rozwijać się we własnym tempie, jednocześnie czerpiąc radość z treningów. Dołącz do nas i zobacz, jak kickboxing może poprawić Twoją formę i samopoczucie!",
    },
    {
        service: "Kickboxing Junior",
        subtitle: "Grupowy",
        coach: "Adrian Spętany",
        coachIds: ["AS1"],
        imgSrc0: "/images/offercards/combat.jpg",
        imgSrc: "/images/offercards/combatoffer.jpg",
        imgAlt: "Zdjęcie zajęć kickboxingu",
        imgSrc2: "/images/kickboxing/kickboxing2.png",
        imgAlt2: "Zdjęcie z zajęć kickboxingu",
        imgSrc3: "/images/kickboxing/kickboxing1.png",
        imgAlt3: "Zdjęcie z zajęć kickboxingu",
        description:
            "Energia, dyscyplina i świetna zabawa w jednym! Na zajęciach dzieci uczą się podstaw kickboxingu, poprawiaja koordynację, pewność siebie i kondycję!",
        users: "Zapraszamy na zajęcia Kickboxing Junior dla dzieci w wieku 8–12 lat! To świetna okazja, aby w aktywny i bezpieczny sposób wprowadzić najmłodszych w świat sportu. Podczas treningów dzieci uczą się podstaw kickboxingu, rozwijają koordynację ruchową, sprawność oraz ogólną kondycję fizyczną. Zajęcia prowadzone są w przyjaznej, pełnej energii atmosferze, która sprzyja budowaniu pewności siebie i pracy w grupie. Stawiamy nie tylko na technikę, ale również na dobrą zabawę, dzięki czemu dzieci chętnie uczestniczą w treningach i rozwijają swoją pasję do sportu. Nasz trener dostosowuje ćwiczenia do wieku i możliwości uczestników, dbając o ich bezpieczeństwo oraz indywidualny rozwój. To idealne miejsce, aby spożytkować energię, nauczyć się dyscypliny i nawiązać nowe znajomości. Dołącz do nas i przekonaj się, jak wiele radości daje kickboxing!",
        timetable: [
            {
                day: "Czwartek",
                time: "17:00 - 18:00",
                coach: "Adrian Spętany",
                groupType: "Dzieci 8-12 lat",
            },
        ],
    },
    {
        service: "Kickboxing",
        subtitle: "Grupowy",
        coach: "Michał Kulej, Jakub Kulej, Adrian Spętany, Patryk Mikulski, Marcin Bachórz",
        coachIds: ["MK1", "JK1", "AS1", "PM1", "MB1"],
        imgSrc0: "/images/offercards/combat.jpg",
        imgSrc: "/images/offercards/combatoffer.jpg",
        imgAlt: "Zdjęcie zajęć kickboxingu",
        imgSrc2: "/images/kickboxing/kickboxing2.png",
        imgAlt2: "Zdjęcie z zajęć kickboxingu",
        imgSrc3: "/images/kickboxing/kickboxing3.png",
        imgAlt3: "Zdjęcie z zajęć kickboxingu",
        description:
            "Kickboxing w grupie to intensywny trening, który łączy techniki walki, pomagając poprawić kondycję, zbudować siłę i pewność siebie w motywującym środowisku.",
        users: "Zapraszamy do grupy kickboxingu, która łączy osoby na różnych poziomach zaawansowania! To idealne miejsce, aby nauczyć się podstaw kickboxingu, a także rozwinąć umiejętności, które już posiadasz. Treningi prowadzone są w przyjaznej i motywującej atmosferze, gdzie każdy może pracować nad swoją kondycją, techniką i pewnością siebie. Nasz trener dostosowuje ćwiczenia do Twojego poziomu, dbając o to, żebyś mógł rozwijać się we własnym tempie, jednocześnie czerpiąc radość z treningów. Dołącz do nas i zobacz, jak kickboxing może poprawić Twoją formę i samopoczucie!",
        timetable: [
            {
                day: "Poniedziałek",
                time: "18:00 - 19:00",
                coach: "Adrian Spętany",
                groupType: "Początkujący",
            },
            {
                day: "Wtorek",
                time: "18:00 - 19:00",
                coach: "Michał Kulej",
                groupType: "Podstawowy",
            },
            {
                day: "Wtorek",
                time: "19:00 - 20:00",
                coach: "Marcin Bachórz",
                groupType: "Open",
            },
            {
                day: "Czwartek",
                time: "18:00 - 19:00",
                coach: "Michał Kulej",
                groupType: "Podstawowy",
            },
            {
                day: "Czwartek",
                time: "19:00-20:00",
                coach: "Marcin Bachórz",
                groupType: "Open",
            },
        ],
    },
    {
        service: "Boks",
        subtitle: "Indywidualny",
        coach: "Michał Kulej, Adrian Spętany, Dominik Warmiłło, Jakub Kulej, Marcin Bachórz, Natalia Klebanowicz, Miłosz Karyś, Patryk Mikulski",
        coachIds: ["MK1", "AS1", "DW1", "JK1", "MB1", "NK1", "MK2", "PM1"],
        imgSrc0: "/images/offercards/combat.jpg",
        imgSrc: "/images/offercards/combatoffer.jpg",
        imgAlt: "Zdjęcie zajęć boksu",
        imgSrc2: "/images/boks/boks2.png",
        imgAlt2: "Zdjęcie z zajęć boksu",
        imgSrc3: "/images/boks/boks3.png",
        imgAlt3: "Zdjęcie z zajęć boksu",
        description:
            "Boks to intensywny trening sportów uderzanych w stójce, który łączy różne elementy koordynacyjne i wytrzymałościowe, skutecznie poprawiając kondycję, siłę i pewność siebie",
        day: "Indywidualne Zapisy",
        users: "Indywidualne zajęcia boksu, prowadzone przez naszych doświadczonych trenerów, są idealne dla osób na różnych poziomach zaawansowania. Niezależnie od Twojego poziomu kondycji, te zajęcia pomogą Ci nauczyć się podstawowych technik, poprawić koordynację i zwiększyć wytrzymałość. Treningi odbywają się w motywującej atmosferze, gdzie każdy uczestnik jest wspierany na każdym etapie nauki. To świetna okazja, żeby spróbować czegoś nowego, zbudować pewność siebie i osiągnąć lepszą formę fizyczną. Dołącz do nas i odkryj, jak boks może stać się Twoją nową pasją!",
    },
    {
        service: "Boks",
        subtitle: "Grupowy",
        coach: "Natalia Klebanowicz",
        coachIds: ["NK1"],
        imgSrc0: "/images/offercards/combat.jpg",
        imgSrc: "/images/offercards/combatoffer.jpg",
        imgAlt: "Zdjęcie zajęć boksu",
        imgSrc2: "/images/boks/boks2.png",
        imgAlt2: "Zdjęcie z zajęć boksu",
        imgSrc3: "/images/boks/boks1.png",
        imgAlt3: "Zdjęcie z zajęć boksu",
        description:
            "Boks w grupie to barwny i intensywny trening, wspólnie poprawiając kondycję, budując siłę i pewność siebie w motywującym środowisku",
        day: "Indywidualne Zapisy",
        users: "Grupa boksu podstawowego, prowadzona przez naszego doświadczonego trenera, jest idealna dla osób, które dopiero zaczynają swoją przygodę z boksem. Niezależnie od Twojego poziomu kondycji, te zajęcia pomogą Ci nauczyć się podstawowych technik, poprawić koordynację i zwiększyć wytrzymałość. Treningi odbywają się w motywującej atmosferze, gdzie każdy uczestnik jest wspierany na każdym etapie nauki. To świetna okazja, żeby spróbować czegoś nowego, zbudować pewność siebie i osiągnąć lepszą formę fizyczną. Dołącz do nas i odkryj, jak boks może stać się Twoją nową pasją!",
        timetable: [
            {
                id: 1,
                day: "Piątek",
                time: "18:00-19:00",
                coach: "Natalia Klebanowicz",
                groupType: "Podstawowy",
            },
            // {
            //     id: 2,
            //     day: "Środa",
            //     time: "19:00-20:00",
            //     coach: "Dominik Warmiłło",
            //     groupType: "Podstawowy",
            // },
        ],
    },
    {
        service: "MMA",
        subtitle: "Indywidualny",
        coach: "Patryk Mikulskki",
        coachIds: ["PM1"],
        imgSrc0: "/images/offercards/combat.jpg",
        imgSrc: "/images/offercards/combatoffer.jpg",
        imgAlt: "Zdjęcie zajęć MMA",
        imgSrc2: "/images/walczaki.jpg",
        imgAlt2: "Zdjęcie z treningu",
        imgSrc3: "/images/offercards/combat.jpg",
        imgAlt3: "Zdjęcie z treningu",
        description:
            "Indywidualny trening MMA dla początkujących w spersonalizowany sposób, wprowadzają w podstawy różnych sztuk walki, rozwijając siłę, kondycję i umiejętności samoobrony w szybkim tempie, dostosowanym do Twoich możliwości.",
        day: "Indywidualne Zapisy",
        users: "Zajęcia indywidualne MMA dla dorosłych to doskonała okazja, aby rozpocząć swoją przygodę z mieszanymi sztukami walki w bezpiecznym środowisku lub rozwijać dotychczas zdobyte umiejętności. Zajęcia, prowadzone przez naszego Trenera, wprowadzają uczestników w podstawy technik z różnych dyscyplin, takich jak boks, kickboxing, zapasy i jiu-jitsu. Treningi są skoncentrowane na rozwijaniu siły, wytrzymałości oraz umiejętności samoobrony, jednocześnie poprawiając kondycję fizyczną i pewność siebie. Uczestnicy uczą się zarówno technik stójkowych, jak i pracy w parterze, co pozwala na wszechstronny rozwój. Atmosfera zajęć jest motywująca, z naciskiem na indywidualne tempo nauki, co sprawia, że każdy, bez względu na wcześniejsze doświadczenie, może czerpać radość z treningów. To idealne miejsce dla tych, którzy chcą poprawić swoją formę fizyczną, nauczyć się skutecznych technik walki i zbudować solidne podstawy w MMA.",
    },
    // {
    //     service: "MMA",
    //     subtitle: "Grupowy",
    //     coach: "Patryk Mikulskki",
    //     coachIds: ["PM1"],
    //     imgSrc0: "/images/offercards/combat.jpg",
    //     imgSrc: "/images/offercards/combatoffer.jpg",
    //     imgAlt: "Zdjęcie zajęć MMA",
    //     imgSrc2: "/images/walczaki.jpg",
    //     imgAlt2: "Zdjęcie z treningu",
    //     imgSrc3: "/images/offercards/combat.jpg",
    //     imgAlt3: "Zdjęcie z treningu",
    //     description:
    //         "Grupowe MMA dla początkujących to intensywny trening, który wprowadza w podstawy mieszanych sztuk walki, rozwijając siłę, kondycję i umiejętności samoobrony w motywującym środowisku.",
    //     day: "Indywidualne Zapisy",
    //     users: "Grupa MMA dla początkujących dorosłych to doskonała okazja, aby rozpocząć swoją przygodę z mieszanymi sztukami walki w bezpiecznym środowisku. Zajęcia, prowadzone przez naszego Trenera, wprowadzają uczestników w podstawy technik z różnych dyscyplin, takich jak boks, kickboxing, zapasy i jiu-jitsu. Treningi są skoncentrowane na rozwijaniu siły, wytrzymałości oraz umiejętności samoobrony, jednocześnie poprawiając kondycję fizyczną i pewność siebie. Uczestnicy uczą się zarówno technik stójkowych, jak i pracy w parterze, co pozwala na wszechstronny rozwój. Atmosfera zajęć jest motywująca, z naciskiem na indywidualne tempo nauki, co sprawia, że każdy, bez względu na wcześniejsze doświadczenie, może czerpać radość z treningów. To idealne miejsce dla tych, którzy chcą poprawić swoją formę fizyczną, nauczyć się skutecznych technik walki i zbudować solidne podstawy w MMA.",
    //     timetable: [
    //         {
    //             id: 1,
    //             day: "Poniedziałek",
    //             time: "20:00-21:00",
    //             coach: "Patryk Mikulski",
    //             groupType: "Początkujący",
    //         },
    //         {
    //             id: 2,
    //             day: "Piątek",
    //             time: "20:00-21:00",
    //             coach: "Patryk Mikulski",
    //             groupType: "Początkujący",
    //         },
    //     ],
    // },
    {
        service: "Stretching",
        subtitle: "Grupowy",
        coach: "Klaudia Żmijewska",
        coachIds: ["KŻ1"],
        imgSrc0: "/images/offercards/combat.jpg",
        imgSrc: "/images/offercards/combatoffer.jpg",
        imgAlt: "Zdjęcie z treningu",
        imgSrc2: "/images/offercards/combat.jpg",
        imgAlt2: "Zdjęcie z treningu",
        imgSrc3: "/images/stretching/stretching1.JPG",
        imgAlt3: "Zdjęcie z treningu",
        description:
            "Stretching to relaksujący trening mobilizacji, który poprawia elastyczność, zwiększa zakres ruchu i pomaga zredukować napięcie mięśni.",
        day: "Indywidualne Zapisy",
        users: "Grupa stretching, prowadzona przez naszą trenerkę medyczną, jest idealna dla osób, które chcą poprawić swoją elastyczność i zwiększyć zakres ruchu, a szczególnie dla tych, którzy na co dzień zmagają się z bólami mięśni i stawów. Zajęcia te pomagają zredukować napięcie mięśniowe, poprawić postawę i zwiększyć ogólną sprawność fizyczną. W bezpiecznej i relaksującej atmosferze nauczysz się technik rozciągania, które przynoszą ulgę i poprawiają samopoczucie. Dołącz do nas i zadbaj o swoje ciało, by czuć się lepiej na co dzień!",
        timetable: [
            {
                id: 1,
                day: "Wtorek",
                time: "09:00-10:00",
                coach: "Klaudia Żmijewska",
                groupType: "Podstawowy",
            },
            // {
            //     id: 2,
            //     day: "Środa",
            //     time: "17:00-18:00",
            //     coach: "Klaudia Żmijewska",
            //     groupType: "Podstawowy",
            // },
        ],
    },
    {
        service: "BJJ",
        subtitle: "Indywidualny",
        coach: "Vladyslav Filenko",
        coachIds: ["VF1"],
        imgSrc0: "/images/offercards/combat.jpg",
        imgSrc: "/images/offercards/combatoffer.jpg",
        imgAlt: "Zdjęcie zajęć BJJ",
        imgSrc2: "/images/walczaki.jpg",
        imgAlt2: "Zdjęcie z treningu",
        imgSrc3: "/images/offercards/combat.jpg",
        imgAlt3: "Zdjęcie z treningu",
        description:
            "Indywidualne zajęcia BJJ to spersonalizowany trening, który pozwala doskonalić techniki walki w parterze, rozwijać siłę i wytrzymałość oraz szybko osiągać założone cele.",
        day: "Indywidualne Zapisy",
        users: "Zajęcia BJJ dla dorosłych, prowadzone przez naszego doświadczonego trenera, są idealne dla tych, którzy chcą wejść w świat brazylijskiego jiu-jitsu od podstaw lub zwiększyć poziom zaawansowania swoich umiejętności. Na zajęciach nauczysz się technik walki w parterze, rozwijając przy tym siłę, koordynację oraz pewność siebie. Treningi są doskonałe dla osób pragnących poprawić swoją sprawność fizyczną, a także nauczyć się skutecznej samoobrony. Dołącz do nas i zacznij swoją przygodę z BJJ w przyjaznej, wspierającej atmosferze!",
    },
    // {
    //     service: "BJJ Adults",
    //     subtitle: "Grupowy",
    //     coach: "Vladyslav Filenko",
    //     coachIds: ["VF1"],
    //     imgSrc0: "/images/offercards/combat.jpg",
    //     imgSrc: "/images/offercards/combatoffer.jpg",
    //     imgAlt: "Zdjęcie zajęć BJJ Adults",
    //     imgSrc2: "/images/walczaki.jpg",
    //     imgAlt2: "Zdjęcie z treningu",
    //     imgSrc3: "/images/offercards/combat.jpg",
    //     imgAlt3: "Zdjęcie z treningu",
    //     description:
    //         "Brazilian Jiu-Jitsu (BJJ) to skuteczny trening walki w parterze z elementami zapasów, który rozwija siłę, wytrzymałość i umiejętność samoobrony.",
    //     day: "Indywidualne Zapisy",
    //     users: "Grupa BJJ dla początkujących dorosłych, prowadzona przez naszego doświadczonego trenera, jest idealna dla tych, którzy chcą wejść w świat brazylijskiego jiu-jitsu od podstaw. Na zajęciach nauczysz się technik walki w parterze, rozwijając przy tym siłę, koordynację oraz pewność siebie. Treningi są doskonałe dla osób pragnących poprawić swoją sprawność fizyczną, a także nauczyć się skutecznej samoobrony. Dołącz do nas i zacznij swoją przygodę z BJJ w przyjaznej, wspierającej atmosferze!",
    //     timetable: [
    //         {
    //             id: 1,
    //             day: "Środa",
    //             time: "18:00-19:00",
    //             coach: "Vladyslav Filenko",
    //             groupType: "Początkujący",
    //         },
    //     ],
    // },
    {
        service: "BJJ Junior",
        subtitle: "Grupowy",
        coach: "Mateusz Flejterski, Vladyslav Filenko",
        coachIds: ["MF1", "VF1"],
        imgSrc0: "/images/offercards/combat.jpg",
        imgSrc: "/images/offercards/combatoffer.jpg",
        imgAlt: "Zdjęcie zajęć BJJ Junior",
        imgSrc2: "/images/bjj/BJJkids.JPG",
        imgAlt2: "Zdjęcie z treningu",
        imgSrc3: "/images/offercards/combat.jpg",
        imgAlt3: "Zdjęcie z treningu",
        description:
            "BJJ Junior to trening, który uczy technik samoobrony, rozwija siłę i koordynację, a także buduje pewność siebie u dzieci w wieku 10-14 lat.",
        day: "Indywidualne Zapisy",
        users: "Grupa BJJ Junior dla dzieci w wieku 10-14 lat, prowadzona przez naszych instruktorów (regularnych zawodników BJJ), to doskonała okazja, aby młodzi uczestnicy mogli rozwijać swoje umiejętności w brazylijskim jiu-jitsu. Te zajęcia są idealne dla dzieci, które chcą nauczyć się technik samoobrony, a jednocześnie poprawić swoją sprawność. Treningi kładą duży nacisk na rozwój pewności siebie oraz umiejętności pracy zespołowej w przyjaznej i bezpiecznej atmosferze. Uczestnicy będą mieli okazję nie tylko nauczyć się skutecznych technik walki w parterze, ale także zrozumieć, jak ważne są zasady fair play i wzajemny szacunek. To świetny sposób, aby dzieci mogły zdrowo spożytkować swoją energię i zbudować solidne podstawy zarówno fizyczne, jak i mentalne na przyszłość.",
        timetable: [
            {
                id: 1,
                day: "Środa",
                time: "16:00-17:00",
                coach: "Vladyslav Filenko",
                groupType: "Początkujący",
            },
            {
                id: 1,
                day: "Sobota",
                time: "11:15-12:15",
                coach: "Mateusz Flejterski",
                groupType: "Początkujący",
            },
        ],
    },
    {
        service: "BJJ Kids",
        subtitle: "Grupowy",
        coach: "Vladyslav Filenko",
        coachIds: ["VF1"],
        imgSrc0: "/images/offercards/combat.jpg",
        imgSrc: "/images/offercards/combatoffer.jpg",
        imgAlt: "Zdjęcie zajęć BJJ Kids",
        imgSrc2: "/images/bjj/BJJkids.JPG",
        imgAlt2: "Zdjęcie z treningu",
        imgSrc3: "/images/offercards/combat.jpg",
        imgAlt3: "Zdjęcie z treningu",
        description:
            "BJJ Junior to trening, który wprowadza dzieci w wieku 6-9 lat w świat samoobrony, rozwijając ich siłę, koordynację oraz budując pewność siebie w przyjaznym środowisku.",
        day: "Indywidualne Zapisy",
        users: "Grupa BJJ Kids dla dzieci w wieku 6-9 lat, prowadzona przez naszego  Trenera, to idealne miejsce, gdzie najmłodsi mogą po raz pierwszy zetknąć się ze światem brazylijskiego jiu-jitsu. Zajęcia są zaprojektowane w sposób, który wprowadza dzieci w techniki walki w parterze poprzez zabawę i dynamiczne ćwiczenia, dostosowane do ich wieku i możliwości. Dzieci uczą się podstawowych ruchów i pozycji, jednocześnie rozwijając koordynację, siłę oraz zwinność. Duży nacisk kładziony jest na budowanie pewności siebie, koncentracji i umiejętności pracy w grupie, dyscyplinę, a także na zasady fair play i wzajemny szacunek. Zajęcia odbywają się w bezpiecznej  atmosferze, na specjalnie przystosowanej do tego sali, a nauka jest prowadzona w sposób przyjemny i motywujący. To doskonała okazja, aby dzieci mogły aktywnie spędzać czas, zdobywając przy tym nowe umiejętności, które będą procentować w przyszłości.",
        timetable: [
            {
                id: 1,
                day: "Sobota",
                time: "09:45-11:45",
                coach: "Vladyslav Filenko",
                groupType: "Początkujący",
            },
        ],
    },
    {
        service: "Maluchy na macie",
        subtitle: "Grupowy",
        coach: "Tomasz Wroński",
        coachIds: ["TW1"],
        imgSrc0: "/images/offercards/combat.jpg",
        imgSrc: "/images/offercards/combatoffer.jpg",
        imgAlt: "Zdjęcie zajęć BJJ Kids",
        imgSrc2: "/images/bjj/BJJkids.JPG",
        imgAlt2: "Zdjęcie z treningu",
        imgSrc3: "/images/offercards/combat.jpg",
        imgAlt3: "Zdjęcie z treningu",
        description:
            "'Maluchy na Macie' to zajęcia pełne zabawy i ruchu, które wprowadzają dzieci w wieku 2,5-5 lat w świat BJJ, rozwijając ich koordynację, zwinność i pewność siebie w radosnej atmosferze.",
        day: "Indywidualne Zapisy",
        users: "Grupa „Maluchy na Macie” dla dzieci w wieku 2,5 do 5 lat to idealne miejsce, gdzie najmłodsi mogą w przyjazny sposób rozpocząć swoją przygodę z aktywnością fizyczną na macie. Zajęcia prowadzone są przez doświadczonego instruktora, skupiają się głównie na zabawach i ćwiczeniach ruchowych, które rozwijają koordynację, zwinność i podstawowe umiejętności motoryczne. Dzieci, bawiąc się na macie, uczą się jednocześnie podstawowych zasad współpracy, skupienia i wzajemnego szacunku. Atmosfera zajęć jest pełna radości i energii, co sprawia, że dzieci chętnie uczestniczą w ćwiczeniach, a jednocześnie budują pewność siebie i zamiłowanie do aktywności fizycznej. To wspaniała okazja, by wprowadzić maluchy w świat ruchu i zdrowych nawyków, które będą im towarzyszyć przez całe życie.",
        timetable: [
            {
                id: 1,
                day: "Sobota",
                time: "9:00-9:45",
                coach: "Tomasz Wroński",
                groupType: "Początkujący",
            },
        ],
    },
];
